/**
 * API Index - Central exports for all messaging API hooks
 *
 * Import pattern examples:
 * import { useChannels, useMessages, useSendMessage } from '@/components/myConversations/api';
 */

// Channels
export { useChannels } from './channels/useChannels';
export { useAllChannels } from './channels/useAllChannels';
export { useChannel } from './channels/useChannel';
export { useCreateChannel } from './channels/useCreateChannel';
export { useRenameChannel } from './channels/useRenameChannel';
export { useArchiveChannel } from './channels/useArchiveChannel';
export { useUnarchiveChannel } from './channels/useUnarchiveChannel';
export { useSearchChannels } from './channels/useSearchChannels';

// Messages
export { useMessages } from './messages/useMessages';
export { useSendMessage } from './messages/useSendMessage';
export { useEditMessage } from './messages/useEditMessage';
export { useDeleteMessage } from './messages/useDeleteMessage';

// Members
export { useMembers } from './members/useMembers';
export { useAddMembers } from './members/useAddMembers';
export { useRemoveMember } from './members/useRemoveMember';
export { useRemoveWhatsappMember } from './members/useRemoveWhatsappMember';
export { useEligibleUsers } from './members/useEligibleUsers';

// Users
export { useInternalUsers } from './users/useInternalUsers';
export { useEligibleUsersForCreation } from './users/useEligibleUsersForCreation';

// Unread
export { useUnreadCounts } from './unread/useUnreadCounts';
export { useMarkAsRead } from './unread/useMarkAsRead';

// Direct Messages
export { useOpenDm } from './directMessages/useOpenDm';

// Files
export { useRequestUpload } from './files/useRequestUpload';
export { useConfirmUpload } from './files/useConfirmUpload';
export { useFiles, downloadFileUrl } from './files/useFiles';
export { useDeleteFile } from './files/useDeleteFile';

// Config & Types
export { messagingQueryKeys, MESSAGING_API_BASE } from './config';
export * from './types/backend';

// Adapters
export {
  adaptChannelToConversation,
  adaptChannelsWithUnreads,
} from './adapters/channelAdapter';
export {
  adaptMessageToWhatsApp,
  adaptMessages,
} from './adapters/messageAdapter';
